<template>
  <div class="tab-pane-inner">
    <div class="inspections-list form-inspection">
      <div class="popup-table-header">
        <h3>{{ $t("COMMON.REPAIRS") }}</h3>
        <base-button
          class="add"
          icon
          size="sm"
          @click="addRepair"
          v-if="this.$currentUserCan(this.$permissions.PERM_CREATE_REPAIRS)"
        >
          <span class="btn-inner--icon">
            <i class="fa-regular fa-circle-plus"></i>
          </span>
          <span class="btn-inner--text">
            {{ $t("REPAIRS.ADD_REPAIR") }}
          </span>
        </base-button>
      </div>
      <repair-list-table
        :add-section="false"
        :columns="tableColumns"
        :filterVehicle="vehicle.id"
        :show-pagination="false"
        @onAddRepair="addRepair"
        @onDeleteRepair="viewRepair"
        @onEditRepair="editRepair"
        @onViewRepair="viewRepair"
        show-all
      />
    </div>
  </div>
</template>

<script>
import {
  QUERY_ACTIONS_ADD,
  QUERY_ACTIONS_EDIT,
  QUERY_ACTIONS_VIEW,
} from "@/constants/common";
import RepairListTable from "@/views/Pages/InspectproModule/RepairManagement/partials/RepairListTable.vue";
import CopyElement from "@/components/CopyElement.vue";
import VehicleRefStandardized from "@/components/VehicleRefStandardized.vue";

export default {
  name: "vehicle-view-repairs",

  components: { RepairListTable, CopyElement, VehicleRefStandardized },

  props: ["vehicle"],

  data() {
    return {
      tableColumns: [
        // "vehicle",
        "vin",
        "customer",
        "model",
        "status",
        // "mechanic",
        "updated_at",
        // "days",
      ],
    };
  },

  computed: {},

  created() {},

  methods: {
    viewRepair(repair) {
      this.$router.push({
        name: "List Repairs",
        query: { id: repair.id, action: QUERY_ACTIONS_VIEW },
      });
    },
    editRepair(repair) {
      this.$router.push({
        name: "List Repairs",
        query: { id: repair.id, action: QUERY_ACTIONS_EDIT },
      });
    },
    addRepair() {
      this.$router.push({
        name: "List Repairs",
        query: {
          action: QUERY_ACTIONS_ADD,
          vehicle_id: this.vehicle.id,
        },
      });
    },
  },

  mounted() {},

  watch: {
    vehicle(vehicle) {},
  },
};
</script>
